import { List, Datagrid, TextField, DateField, NumberField, BooleanField } from 'react-admin';

export const Tbl_giornataList = props => (
    <List {...props} sort={{ field: 'numero', order: 'ASC' }}>
        <Datagrid rowClick="edit">
            <NumberField source="id" />
            <NumberField source="legaStagioneId" />
            <NumberField source="legaId" />
            <NumberField source="stagioneId" />
            <NumberField source="numero" />
            <TextField source="nome" />
            <DateField source="dataInizio" />
            <DateField source="dataFine" />
            <TextField source="note" />
            <BooleanField source="flDisputata" />
            <BooleanField source="flVisibile" />
            <BooleanField source="flAttivo" />
            <BooleanField source="flAnnullato" />
            <NumberField source="ordinamento" />
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
        </Datagrid>
    </List>
);
